export default __webpack_public_path__ + "static/media/image2.579e45dd.png";